"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryAdHintInteractionTrack = exports.TileInteractionTrack = exports.TileImpressionTrack = exports.StorySnapImpressionTrack = exports.StoryImpressionTrack = void 0;
const three_v_impression_track_1 = require("./three_v_impression_track");
const app_install_impression_track_1 = require("./app_install_impression_track");
const longform_video_impression_track_1 = require("./longform_video_impression_track");
const remote_webpage_impression_track_1 = require("./remote_webpage_impression_track");
const local_webpage_impression_track_1 = require("./local_webpage_impression_track");
const deep_link_impression_track_1 = require("./deep_link_impression_track");
const subscribe_impression_track_1 = require("./subscribe_impression_track");
const ad_to_lens_impression_track_1 = require("./ad_to_lens_impression_track");
const ad_to_call_impression_track_1 = require("./ad_to_call_impression_track");
const ad_to_message_impression_track_1 = require("./ad_to_message_impression_track");
const showcase_impression_track_1 = require("./showcase_impression_track");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
function createBaseStoryImpressionTrack() {
    return {
        timeViewedSeconds: undefined,
        mediaDurationSeconds: undefined,
        snapCount: undefined,
        viewedSnapIndex: undefined,
        exitEvent: 0,
        uniqueSwipeUps: undefined,
        totalSwipeUps: undefined,
        isAudioOn: undefined,
        snapImpressions: [],
        tileImpression: undefined,
        creativeId: new Uint8Array(),
        tileInteraction: undefined,
        updatedTileIndexPosition: undefined,
        storyAdHintInteraction: undefined,
    };
}
exports.StoryImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.timeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.timeViewedSeconds }, writer.uint32(10).fork()).ldelim();
        }
        if (message.mediaDurationSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.mediaDurationSeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.snapCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.snapCount }, writer.uint32(26).fork()).ldelim();
        }
        if (message.viewedSnapIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.viewedSnapIndex }, writer.uint32(34).fork()).ldelim();
        }
        if (message.exitEvent !== 0) {
            writer.uint32(40).int32(message.exitEvent);
        }
        if (message.uniqueSwipeUps !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.uniqueSwipeUps }, writer.uint32(50).fork()).ldelim();
        }
        if (message.totalSwipeUps !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.totalSwipeUps }, writer.uint32(58).fork()).ldelim();
        }
        if (message.isAudioOn !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isAudioOn }, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.snapImpressions) {
            exports.StorySnapImpressionTrack.encode(v, writer.uint32(74).fork()).ldelim();
        }
        if (message.tileImpression !== undefined) {
            exports.TileImpressionTrack.encode(message.tileImpression, writer.uint32(82).fork()).ldelim();
        }
        if (message.creativeId.length !== 0) {
            writer.uint32(90).bytes(message.creativeId);
        }
        if (message.tileInteraction !== undefined) {
            exports.TileInteractionTrack.encode(message.tileInteraction, writer.uint32(98).fork()).ldelim();
        }
        if (message.updatedTileIndexPosition !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.updatedTileIndexPosition }, writer.uint32(106).fork()).ldelim();
        }
        if (message.storyAdHintInteraction !== undefined) {
            exports.StoryAdHintInteractionTrack.encode(message.storyAdHintInteraction, writer.uint32(114).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoryImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.timeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.mediaDurationSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.snapCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.viewedSnapIndex = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.exitEvent = reader.int32();
                    break;
                case 6:
                    message.uniqueSwipeUps = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.totalSwipeUps = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.isAudioOn = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.snapImpressions.push(exports.StorySnapImpressionTrack.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.tileImpression = exports.TileImpressionTrack.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.creativeId = reader.bytes();
                    break;
                case 12:
                    message.tileInteraction = exports.TileInteractionTrack.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.updatedTileIndexPosition = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 14:
                    message.storyAdHintInteraction = exports.StoryAdHintInteractionTrack.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseStoryImpressionTrack();
        message.timeViewedSeconds = object.timeViewedSeconds ?? undefined;
        message.mediaDurationSeconds = object.mediaDurationSeconds ?? undefined;
        message.snapCount = object.snapCount ?? undefined;
        message.viewedSnapIndex = object.viewedSnapIndex ?? undefined;
        message.exitEvent = object.exitEvent ?? 0;
        message.uniqueSwipeUps = object.uniqueSwipeUps ?? undefined;
        message.totalSwipeUps = object.totalSwipeUps ?? undefined;
        message.isAudioOn = object.isAudioOn ?? undefined;
        message.snapImpressions =
            object.snapImpressions?.map((e) => exports.StorySnapImpressionTrack.fromPartial(e)) || [];
        message.tileImpression =
            object.tileImpression !== undefined && object.tileImpression !== null
                ? exports.TileImpressionTrack.fromPartial(object.tileImpression)
                : undefined;
        message.creativeId = object.creativeId ?? new Uint8Array();
        message.tileInteraction =
            object.tileInteraction !== undefined && object.tileInteraction !== null
                ? exports.TileInteractionTrack.fromPartial(object.tileInteraction)
                : undefined;
        message.updatedTileIndexPosition =
            object.updatedTileIndexPosition ?? undefined;
        message.storyAdHintInteraction =
            object.storyAdHintInteraction !== undefined &&
                object.storyAdHintInteraction !== null
                ? exports.StoryAdHintInteractionTrack.fromPartial(object.storyAdHintInteraction)
                : undefined;
        return message;
    },
};
function createBaseStorySnapImpressionTrack() {
    return {
        snapIndex: undefined,
        swipeUpCount: undefined,
        skipEvent: 0,
        adType: 0,
        typedTrackData: undefined,
    };
}
exports.StorySnapImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.snapIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.snapIndex }, writer.uint32(10).fork()).ldelim();
        }
        if (message.swipeUpCount !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.swipeUpCount }, writer.uint32(18).fork()).ldelim();
        }
        if (message.skipEvent !== 0) {
            writer.uint32(24).int32(message.skipEvent);
        }
        if (message.adType !== 0) {
            writer.uint32(32).int32(message.adType);
        }
        if (message.typedTrackData?.$case === "threeV") {
            three_v_impression_track_1.ThreeVImpressionTrack.encode(message.typedTrackData.threeV, writer.uint32(42).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "appInstall") {
            app_install_impression_track_1.AppInstallImpressionTrack.encode(message.typedTrackData.appInstall, writer.uint32(50).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "longformVideo") {
            longform_video_impression_track_1.LongformVideoImpressionTrack.encode(message.typedTrackData.longformVideo, writer.uint32(58).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "remoteWebpage") {
            remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.encode(message.typedTrackData.remoteWebpage, writer.uint32(66).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "localWebpage") {
            local_webpage_impression_track_1.LocalWebpageImpressionTrack.encode(message.typedTrackData.localWebpage, writer.uint32(74).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "deepLink") {
            deep_link_impression_track_1.DeepLinkImpressionTrack.encode(message.typedTrackData.deepLink, writer.uint32(82).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "subscribe") {
            subscribe_impression_track_1.SubscribeImpressionTrack.encode(message.typedTrackData.subscribe, writer.uint32(90).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToLens") {
            ad_to_lens_impression_track_1.AdToLensImpressionTrack.encode(message.typedTrackData.adToLens, writer.uint32(98).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToCall") {
            ad_to_call_impression_track_1.AdToCallImpressionTrack.encode(message.typedTrackData.adToCall, writer.uint32(106).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "adToMessage") {
            ad_to_message_impression_track_1.AdToMessageImpressionTrack.encode(message.typedTrackData.adToMessage, writer.uint32(114).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "showcase") {
            showcase_impression_track_1.ShowcaseImpressionTrack.encode(message.typedTrackData.showcase, writer.uint32(122).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStorySnapImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.snapIndex = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.swipeUpCount = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.skipEvent = reader.int32();
                    break;
                case 4:
                    message.adType = reader.int32();
                    break;
                case 5:
                    message.typedTrackData = {
                        $case: "threeV",
                        threeV: three_v_impression_track_1.ThreeVImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 6:
                    message.typedTrackData = {
                        $case: "appInstall",
                        appInstall: app_install_impression_track_1.AppInstallImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.typedTrackData = {
                        $case: "longformVideo",
                        longformVideo: longform_video_impression_track_1.LongformVideoImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.typedTrackData = {
                        $case: "remoteWebpage",
                        remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.typedTrackData = {
                        $case: "localWebpage",
                        localWebpage: local_webpage_impression_track_1.LocalWebpageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 10:
                    message.typedTrackData = {
                        $case: "deepLink",
                        deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 11:
                    message.typedTrackData = {
                        $case: "subscribe",
                        subscribe: subscribe_impression_track_1.SubscribeImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 12:
                    message.typedTrackData = {
                        $case: "adToLens",
                        adToLens: ad_to_lens_impression_track_1.AdToLensImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 13:
                    message.typedTrackData = {
                        $case: "adToCall",
                        adToCall: ad_to_call_impression_track_1.AdToCallImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 14:
                    message.typedTrackData = {
                        $case: "adToMessage",
                        adToMessage: ad_to_message_impression_track_1.AdToMessageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 15:
                    message.typedTrackData = {
                        $case: "showcase",
                        showcase: showcase_impression_track_1.ShowcaseImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseStorySnapImpressionTrack();
        message.snapIndex = object.snapIndex ?? undefined;
        message.swipeUpCount = object.swipeUpCount ?? undefined;
        message.skipEvent = object.skipEvent ?? 0;
        message.adType = object.adType ?? 0;
        if (object.typedTrackData?.$case === "threeV" &&
            object.typedTrackData?.threeV !== undefined &&
            object.typedTrackData?.threeV !== null) {
            message.typedTrackData = {
                $case: "threeV",
                threeV: three_v_impression_track_1.ThreeVImpressionTrack.fromPartial(object.typedTrackData.threeV),
            };
        }
        if (object.typedTrackData?.$case === "appInstall" &&
            object.typedTrackData?.appInstall !== undefined &&
            object.typedTrackData?.appInstall !== null) {
            message.typedTrackData = {
                $case: "appInstall",
                appInstall: app_install_impression_track_1.AppInstallImpressionTrack.fromPartial(object.typedTrackData.appInstall),
            };
        }
        if (object.typedTrackData?.$case === "longformVideo" &&
            object.typedTrackData?.longformVideo !== undefined &&
            object.typedTrackData?.longformVideo !== null) {
            message.typedTrackData = {
                $case: "longformVideo",
                longformVideo: longform_video_impression_track_1.LongformVideoImpressionTrack.fromPartial(object.typedTrackData.longformVideo),
            };
        }
        if (object.typedTrackData?.$case === "remoteWebpage" &&
            object.typedTrackData?.remoteWebpage !== undefined &&
            object.typedTrackData?.remoteWebpage !== null) {
            message.typedTrackData = {
                $case: "remoteWebpage",
                remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.fromPartial(object.typedTrackData.remoteWebpage),
            };
        }
        if (object.typedTrackData?.$case === "localWebpage" &&
            object.typedTrackData?.localWebpage !== undefined &&
            object.typedTrackData?.localWebpage !== null) {
            message.typedTrackData = {
                $case: "localWebpage",
                localWebpage: local_webpage_impression_track_1.LocalWebpageImpressionTrack.fromPartial(object.typedTrackData.localWebpage),
            };
        }
        if (object.typedTrackData?.$case === "deepLink" &&
            object.typedTrackData?.deepLink !== undefined &&
            object.typedTrackData?.deepLink !== null) {
            message.typedTrackData = {
                $case: "deepLink",
                deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.fromPartial(object.typedTrackData.deepLink),
            };
        }
        if (object.typedTrackData?.$case === "subscribe" &&
            object.typedTrackData?.subscribe !== undefined &&
            object.typedTrackData?.subscribe !== null) {
            message.typedTrackData = {
                $case: "subscribe",
                subscribe: subscribe_impression_track_1.SubscribeImpressionTrack.fromPartial(object.typedTrackData.subscribe),
            };
        }
        if (object.typedTrackData?.$case === "adToLens" &&
            object.typedTrackData?.adToLens !== undefined &&
            object.typedTrackData?.adToLens !== null) {
            message.typedTrackData = {
                $case: "adToLens",
                adToLens: ad_to_lens_impression_track_1.AdToLensImpressionTrack.fromPartial(object.typedTrackData.adToLens),
            };
        }
        if (object.typedTrackData?.$case === "adToCall" &&
            object.typedTrackData?.adToCall !== undefined &&
            object.typedTrackData?.adToCall !== null) {
            message.typedTrackData = {
                $case: "adToCall",
                adToCall: ad_to_call_impression_track_1.AdToCallImpressionTrack.fromPartial(object.typedTrackData.adToCall),
            };
        }
        if (object.typedTrackData?.$case === "adToMessage" &&
            object.typedTrackData?.adToMessage !== undefined &&
            object.typedTrackData?.adToMessage !== null) {
            message.typedTrackData = {
                $case: "adToMessage",
                adToMessage: ad_to_message_impression_track_1.AdToMessageImpressionTrack.fromPartial(object.typedTrackData.adToMessage),
            };
        }
        if (object.typedTrackData?.$case === "showcase" &&
            object.typedTrackData?.showcase !== undefined &&
            object.typedTrackData?.showcase !== null) {
            message.typedTrackData = {
                $case: "showcase",
                showcase: showcase_impression_track_1.ShowcaseImpressionTrack.fromPartial(object.typedTrackData.showcase),
            };
        }
        return message;
    },
};
function createBaseTileImpressionTrack() {
    return {
        isViewed: undefined,
        isViewedAppSession: undefined,
        tileTapped: undefined,
        tileTimeViewedSeconds: undefined,
        hasCta: undefined,
        ctaTapped: undefined,
    };
}
exports.TileImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isViewed !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isViewed }, writer.uint32(10).fork()).ldelim();
        }
        if (message.isViewedAppSession !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isViewedAppSession }, writer.uint32(18).fork()).ldelim();
        }
        if (message.tileTapped !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.tileTapped }, writer.uint32(26).fork()).ldelim();
        }
        if (message.tileTimeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.tileTimeViewedSeconds }, writer.uint32(34).fork()).ldelim();
        }
        if (message.hasCta !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.hasCta }, writer.uint32(42).fork()).ldelim();
        }
        if (message.ctaTapped !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.ctaTapped }, writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTileImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isViewed = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.isViewedAppSession = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.tileTapped = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.tileTimeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.hasCta = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.ctaTapped = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTileImpressionTrack();
        message.isViewed = object.isViewed ?? undefined;
        message.isViewedAppSession = object.isViewedAppSession ?? undefined;
        message.tileTapped = object.tileTapped ?? undefined;
        message.tileTimeViewedSeconds = object.tileTimeViewedSeconds ?? undefined;
        message.hasCta = object.hasCta ?? undefined;
        message.ctaTapped = object.ctaTapped ?? undefined;
        return message;
    },
};
function createBaseTileInteractionTrack() {
    return {
        ctaTapped: undefined,
        tileTimeViewedSeconds: undefined,
        typedTrackData: undefined,
    };
}
exports.TileInteractionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ctaTapped !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.ctaTapped }, writer.uint32(10).fork()).ldelim();
        }
        if (message.tileTimeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.tileTimeViewedSeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "appInstall") {
            app_install_impression_track_1.AppInstallImpressionTrack.encode(message.typedTrackData.appInstall, writer.uint32(26).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "remoteWebpage") {
            remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.encode(message.typedTrackData.remoteWebpage, writer.uint32(34).fork()).ldelim();
        }
        if (message.typedTrackData?.$case === "deepLink") {
            deep_link_impression_track_1.DeepLinkImpressionTrack.encode(message.typedTrackData.deepLink, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTileInteractionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ctaTapped = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.tileTimeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.typedTrackData = {
                        $case: "appInstall",
                        appInstall: app_install_impression_track_1.AppInstallImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 4:
                    message.typedTrackData = {
                        $case: "remoteWebpage",
                        remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                case 5:
                    message.typedTrackData = {
                        $case: "deepLink",
                        deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTileInteractionTrack();
        message.ctaTapped = object.ctaTapped ?? undefined;
        message.tileTimeViewedSeconds = object.tileTimeViewedSeconds ?? undefined;
        if (object.typedTrackData?.$case === "appInstall" &&
            object.typedTrackData?.appInstall !== undefined &&
            object.typedTrackData?.appInstall !== null) {
            message.typedTrackData = {
                $case: "appInstall",
                appInstall: app_install_impression_track_1.AppInstallImpressionTrack.fromPartial(object.typedTrackData.appInstall),
            };
        }
        if (object.typedTrackData?.$case === "remoteWebpage" &&
            object.typedTrackData?.remoteWebpage !== undefined &&
            object.typedTrackData?.remoteWebpage !== null) {
            message.typedTrackData = {
                $case: "remoteWebpage",
                remoteWebpage: remote_webpage_impression_track_1.RemoteWebpageImpressionTrack.fromPartial(object.typedTrackData.remoteWebpage),
            };
        }
        if (object.typedTrackData?.$case === "deepLink" &&
            object.typedTrackData?.deepLink !== undefined &&
            object.typedTrackData?.deepLink !== null) {
            message.typedTrackData = {
                $case: "deepLink",
                deepLink: deep_link_impression_track_1.DeepLinkImpressionTrack.fromPartial(object.typedTrackData.deepLink),
            };
        }
        return message;
    },
};
function createBaseStoryAdHintInteractionTrack() {
    return { expandButtonSnapIndex: undefined, expandButtonTapped: undefined };
}
exports.StoryAdHintInteractionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.expandButtonSnapIndex !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.expandButtonSnapIndex }, writer.uint32(10).fork()).ldelim();
        }
        if (message.expandButtonTapped !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.expandButtonTapped }, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoryAdHintInteractionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.expandButtonSnapIndex = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.expandButtonTapped = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseStoryAdHintInteractionTrack();
        message.expandButtonSnapIndex = object.expandButtonSnapIndex ?? undefined;
        message.expandButtonTapped = object.expandButtonTapped ?? undefined;
        return message;
    },
};
//# sourceMappingURL=story_impression_track.js.map